//tournament_profile_img.js
import { useState } from "react";
import { FaCamera, FaTrophy } from "react-icons/fa";

const CircleTournamentAvatar = ({ size = 100, imageSrc, onImageSelect }) => {
  const [localImage, setLocalImage] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLocalImage(reader.result);
      };
      reader.readAsDataURL(file);
      if (onImageSelect) onImageSelect(event);
    }
  };

  const finalImage = localImage || imageSrc;

  return (
    <div className="relative mb-14" style={{ width: size, height: size }}>
      <div
        className="rounded-full overflow-hidden border"
        style={{
          width: size,
          height: size,
          backgroundColor: "#5C2E91",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {finalImage ? (
          <img
            src={finalImage}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        ) : (
          <FaTrophy size={size / 2} color="#E5960E" />
        )}
      </div>

      <label
        htmlFor="avatar-upload"
        className="absolute bottom-0 right-0 bg-green-500 text-white p-2 rounded-full cursor-pointer hover:bg-green-600"
        style={{ transform: "translate(-5%, 0%)" }}
      >
        <FaCamera />
        <input
          type="file"
          id="avatar-upload"
          accept="image/*"
          className="hidden"
          onChange={handleImageChange}
        />
      </label>
    </div>
  );
};

export default CircleTournamentAvatar;
